import React from "react"
import LoaderBox from "src/components/forms/fragments/LoaderBox"
import get from "lodash/get"
import NotFoundSideModal from "src/components/NotFoundSideModal"
import PropTypes from "prop-types"
import hocInterface from "src/helpers/hocInterface"
import NotFoundPage from "src/components/pages/NotFound"
import pick from "ramda/es/pick"
import styles from "./styles.css"

export const goBack = ({ push, location: { pathname, search } }) => {
  const pathnameArr = pathname.split(`/`)
  pathnameArr.pop()
  const pageRegex = /(?<pageStr>page=)\d+/gi
  const matchObj = pageRegex.exec(search)
  const query =
    matchObj === null
      ? search
      : search.replace(pageRegex, `${matchObj.groups.pageStr}${1}`)
  const newPathname = pathnameArr.join(`/`) + query
  push(newPathname)
}

/**
 * @function
 * @description HOC that shows either a spinner or 404 page
 * @param {string} to - a property name with data from transport.js HOC
 * @param {string} message - a string for 404 message
 * @param {boolean} fullWidth - is a full width modal
 * @returns {function} a HOC
 */
const withSideModalPending = (to, message, fullWidth) =>
  hocInterface(
    {
      injectProps: {
        history: PropTypes.object,
        [to]: PropTypes.shape({
          pending: PropTypes.bool,
          error: PropTypes.shape({
            data: PropTypes.shape({
              status: PropTypes.number,
            }),
          }),
        }),
      },
      exposeProps: pick([`handleUpdate`, `message`]),
    },
    BaseComponent => props => {
      const { history } = props
      const pending = get(props, `${to}.pending`)
      const isNotFound = get(props, `${to}.error.data.status`) === 404
      return isNotFound && !pending ? (
        (fullWidth && <NotFoundPage />) || (
          <NotFoundSideModal
            handleUpdate={() => goBack(history)}
            message={message}
          />
        )
      ) : (
        <div className={styles.Container}>
          {pending && (
            <div className={styles.LoaderWrapper}>
              <LoaderBox />
            </div>
          )}
          <BaseComponent {...props} />
        </div>
      )
    },
  )

export default withSideModalPending
